export default __webpack_public_path__ + "media/images/banners/bnr_tohoku-b103b77ade41ffe9787bb3f6e09426b1.png";